import { useIntl } from 'react-intl';
import { RadioButtonsGroup } from 'sonata-react-components';

import { groupingMessages } from '../groupingMessages';

import './groupingModeSelector.scss';

/** How "New group" groups the selected items: one named group, or one group per cartographic area. */
export type GroupingMode = 'custom' | 'cartography';

export interface GroupingModeSelectorProps {
  /** Prefix of the DOM ids (the radio ids must be unique in the page). */
  id: string;
  mode: GroupingMode;
  onChange: (mode: GroupingMode) => void;
}

/** "Grouping mode": Custom | Cartographic. */
export function GroupingModeSelector({ id, mode, onChange }: Readonly<GroupingModeSelectorProps>) {
  const { formatMessage } = useIntl();
  const customId = `${id}-groupingMode-custom`;
  const cartographyId = `${id}-groupingMode-cartography`;

  return (
    <fieldset className="groupingModeSelector">
      <legend className="groupingModeSelector__label">{formatMessage(groupingMessages.groupingMode)}</legend>
      <RadioButtonsGroup
        id={`${id}-groupingMode`}
        items={[
          { id: customId, text: formatMessage(groupingMessages.groupingModeCustom) },
          { id: cartographyId, text: formatMessage(groupingMessages.groupingModeCartography) }
        ]}
        onChange={value => onChange(value === cartographyId ? 'cartography' : 'custom')}
        tiny
        value={mode === 'cartography' ? cartographyId : customId}
        withContainer={false}
      />
    </fieldset>
  );
}
